import { CONFERENCE_ACT_STATUS } from '@/utils/constant'
import { calcTimeRange } from '@/utils/ops'
import { List, Avatar } from 'ant-design-vue'

export default {
  props: {
    meta: {
      type: Object,
      required: true
    }
  },
  data(){
    return {
      timeRange: calcTimeRange(this.meta)
    }
  },
  components: {
    Meta: List.Item.Meta,
    Avatar
  },
  computed: {
    actStatusText() {
      const actType = this.meta.actType
      switch (actType) {
        case CONFERENCE_ACT_STATUS.INVITE_NTY:
          return this.$t('personSetting.InviteParty')
        case CONFERENCE_ACT_STATUS.CANCEL_NTY:
          return this.$t('personSetting.Cancelled')
        case CONFERENCE_ACT_STATUS.STOP_NTY:
          return this.$t('personSetting.Closed')
        case CONFERENCE_ACT_STATUS.REMOVE_MEMBER_NTY:
          return this.$t('personSetting.BeRemoved')
        case CONFERENCE_ACT_STATUS.FILES_NTY:
          return this.$t('personSetting.UploadFileTo')
        default:
          return this.$t('personSetting.Update')
      }
    },
    actStatus() {
      return CONFERENCE_ACT_STATUS
    }
  }
}
